import axiosInstance from '@/plugins/axios';

const BASE = '/api/audio-contents';

export const actions = {
    async fetchList(params = {}) {
        this.listLoading = true;
        try {
            const { data } = await axiosInstance.get(BASE, {
                params: { include: 'author,cover,audio', ...params },
            });
            this.list = data.data ?? data ?? [];
            return this.list;
        } catch (error) {
            console.error('Error fetching audio contents:', error);
            throw error;
        } finally {
            this.listLoading = false;
        }
    },

    async fetchOne(id) {
        try {
            const { data } = await axiosInstance.get(`${BASE}/${id}`, {
                params: { include: 'author,cover,audio' },
            });
            const item = data.data ?? data;
            const idx = this.list.findIndex((x) => Number(x.id) === Number(id));
            if (idx >= 0) this.list[idx] = item;
            else this.list.push(item);
            return item;
        } catch (error) {
            console.error('Error fetching audio content:', error);
            throw error;
        }
    },

    async create(payload) {
        try {
            const { data } = await axiosInstance.post(BASE, payload);
            const item = data.data ?? data;
            this.list.push(item);
            return item;
        } catch (error) {
            console.error('Error creating audio content:', error);
            throw error;
        }
    },

    async update({ id, ...payload }) {
        try {
            const { data } = await axiosInstance.put(`${BASE}/${id}`, payload);
            const item = data.data ?? data;
            const idx = this.list.findIndex((x) => Number(x.id) === Number(id));
            if (idx >= 0) this.list[idx] = item;
            return item;
        } catch (error) {
            console.error('Error updating audio content:', error);
            throw error;
        }
    },

    async delete(id) {
        try {
            await axiosInstance.delete(`${BASE}/${id}`);
            this.list = this.list.filter((x) => Number(x.id) !== Number(id));
        } catch (error) {
            console.error('Error deleting audio content:', error);
            throw error;
        }
    },

    async uploadCover(id, file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('media_collection', 'cover');
        await axiosInstance.post(`${BASE}/${id}/files`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    async uploadAudio(id, file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('media_collection', 'audio');
        await axiosInstance.post(`${BASE}/${id}/files`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    async attachContentFeed(id, contentFeedId) {
        const { data } = await axiosInstance.put(`${BASE}/${id}/content-feeds/${contentFeedId}/attach`, {
            model_type: 'Laraplate\\Entities\\AudioContent\\Models\\AudioContent',
        });
        return data?.data ?? data;
    },
};
